// Icons
// keep in sync with format.css
export const icons = [
    'camera',
    'camera-movie',
    'close',
    'comment',
    'eye',
    'file-pdf',
    'hands-wash',
    'house',
    'lock',
    'memo-circle-check',
    'memo-circle-info',
    'pencil',
    'qrcode',
    'skeleton',
    'video',
    'location-dot',
    'lightbulb',
    'triangle-exclamation',
    'circle-info',
    'star',
    'thumbtack',
    'circle-check',
    'book',
    'link',
    'clipboard-list-check',
    'heart',
    'face-smile',
    'face-frown'
]

export const iconClasses = [
    'mds-fa',
    ...icons.map(key => `mds-fa-${key}`)
];